export default {
  visaoGeral: `Visão geral`
};
